import { useEffect } from "react";

import { loadWebPushRecoveryClient } from "@/lib/webPushRecoveryClient";

let started = false;

/** Repairs existing local material once per document, without account-session reads. */
export function useWebPushRecovery() {
  useEffect(() => {
    if (started || !("serviceWorker" in navigator) || !("PushManager" in window)) return;
    started = true;
    void navigator.serviceWorker
      .getRegistration("/")
      .then(async (existing) => {
        if (!existing) return;
        const registration = await navigator.serviceWorker.register("/push-sw.js", {
          scope: "/",
          updateViaCache: "none",
        });
        const recovery = await loadWebPushRecoveryClient();
        await recovery.synchronize({ registration });
      })
      .catch(() => undefined);
  }, []);
}
